
import '../plugins/LoadMorePlugin.js';

// load more init
export default function initLoadMore() {
	jQuery('.load-more-box-scroll').loadMore({
		newContentTarget: '.ajax-load-content',
		newContentSelector: '.ajax-load-content',
		linkSelector: 'a.load-more',
		additionBottomOffset: 100,
		scroll: true
	});

	jQuery('.load-more-box').loadMore({
		newContentTarget: '.ajax-load-content',
		newContentSelector: '.ajax-load-content',
		linkSelector: 'a.load-more'
	});

	jQuery('.load-more-holder').loadMore({
		newContentTarget: '.load-more-content',
		newContentSelector: '.load-more-content',
		linkSelector: 'a.load-more'
	});
}